import { DownloadFileFormat } from '../../../server/graphql/__generated.types';

const performDownload = (inputs: {
  fileFormat: DownloadFileFormat;
  friendlyFileName: string;
  signedURL: string;
}) => {
  const { fileFormat, friendlyFileName, signedURL } = inputs;

  const link = document.createElement('a');
  link.href = signedURL;
  link.setAttribute('download', `${friendlyFileName}.${fileFormat}`);

  // Append to html link element page
  document.body.appendChild(link);

  // Start download
  link.click();

  // Clean up and remove the link
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  }
};

export default performDownload;
